export default "__VITE_ASSET__DGdMEoZU__"